'use client';

import { SelectedPage } from '@/types/types';
import { useMediaQuery } from '@mantine/hooks';
import { Box } from '@mantine/core';
import Image from 'next/image';
import { TitleBox } from './TitleBox/TitleBox';
import { MobileTitleBox } from './TitleBox/MobileTitleBox';
import { useEffect } from 'react';
import { useParallax } from 'react-scroll-parallax';

import MobileBG from '@/../public/bg/MobileBG2.png';
import { setSelectedPage } from '@/features/menuLinks/menuLinksSlice';
import { useAppDispatch, useAppSelector } from '@/hooks/reduxHooks';
import { useInView } from 'react-intersection-observer';
import dynamic from 'next/dynamic';
import HeroImage from './HeroImage/HeroImage';
import HeroImageMobile from './HeroImage/HeroImageMobile';

const Video = dynamic(() => import('../Urban/Video'), { ssr: false });

const MeshShapePrimaryReduced = dynamic(
  () => import('@/../public/bg/meshShapePrimaryReduced.svg'),
  { ssr: false }
);
const HeroImageChartNarrowSVGLG = dynamic(
  () => import('@/../public/bg/HeroImageChartNarrowLG.svg'),
  { ssr: false }
);

const HeroImageChartNarrowSVGLGLight = dynamic(
  () => import('@/../public/bg/HeroImageChartNarrowLGLight.svg'),
  { ssr: false }
);

export const HeroSection = () => {
  const theme = useAppSelector((state) => state.theme.theme);
  const isOnLargeScreen = useMediaQuery('(min-width: 1060px)');

  const { ref: bgMeshRef } = useParallax<HTMLDivElement>({
    speed: 15,
    scale: [0.7, 1.2],
    rotate: [0, 12],
  });

  const dispatch = useAppDispatch();
  const { ref, inView } = useInView({
    threshold: 0.2,
  });

  useEffect(() => {
    if (inView) {
      dispatch(setSelectedPage(SelectedPage.Home));
    }
  }, [inView, dispatch]);

  return (
    <Box
      className={
        isOnLargeScreen
          ? `hero-section-${theme === 'light' ? 'light-' : ''}background`
          : `mobile-hero-section-${theme === 'light' ? 'light-' : ''}background items-center justify-center`
      }
      ref={ref}
      id="home"
      style={{
        position: 'relative',
        width: '100%',
        height: isOnLargeScreen ? '100%' : '100%',
        overflow: 'hidden',
        zIndex: 50,
      }}
    >
      {isOnLargeScreen ? (
        <div
          className="left-0 ml-0"
          ref={bgMeshRef}
          style={{
            position: 'absolute',
            left: '-40vw',
            top: '10vh',
            width: '100%',
            height: '100%',
            zIndex: 1,
            rotate: '0deg',
            overflow: 'visible',
          }}
        >
          <Box className="h-full w-full opacity-15">
            <MeshShapePrimaryReduced />
          </Box>
        </div>
      ) : (
        <div ref={bgMeshRef} style={{ position: 'absolute' }}></div>
      )}

      {/* <Box
        id="heroimage"
        className="absolute right-[50%] translate-x-[50%] hidden h-full w-2/3 items-center justify-end md:flex"
      >
        {theme === 'light' ? (
          <HeroImageChartNarrowSVGLGLight />
        ) : (
          <HeroImageChartNarrowSVGLG />
        )}
      </Box> */}

      <Box
        className="my-0 md:mt-32 md:mb-20 flex h-full flex-col"
        style={{
          position: 'relative',
          zIndex: 20,
          display: 'flex',
          justifyContent: 'start',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <Box className="flex h-full w-full items-start justify-center overflow-visible xxs:mx-[20px] xxs:max-md:mt-0 xxs:max-md:items-center xxs:max-md:justify-center md:mx-[120px] md:px-[120px] lg:px-[120px] xl:px-[240px]">
          <Box className="flex h-full w-full xxs:max-md:flex-col items-start">
            <Box className="relative flex h-full w-full flex-col xxs:max-md:items-center xxs:max-md:justify-center xxs:max-md:mt-20">
              {isOnLargeScreen ? <TitleBox /> : <MobileTitleBox />}
              {/* <Image
                src={MobileBG}
                alt="Chart Hero Image"
                className="md:hidden"
                fill
                quality={100}
                style={{
                  objectFit: 'cover',
                  overflow: 'visible',
                  opacity: 1,
                  zIndex: -1,
                }}
              /> */}
            </Box>
            <Video />
            {/* {isOnLargeScreen ? <HeroImage /> : <HeroImageMobile />} */}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
